"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootUnreadOnlyFromDOM = exports.mobilePrefEnabled = exports.bootAdminDashboardFromDOM = exports.bootAdminEligibilityFromDOM = exports.bootAdminDeliveriesFromDOM = exports.bootAdminCampaignsLanguageOptionsFromDOM = exports.bootAdminCampaignLanguageOptionsFromDOM = exports.bootAdminCampaignsRoleOptionsFromDOM = exports.bootAdminCampaignRoleOptionsFromDOM = exports.bootAdminCampaignFromDOM = exports.bootAdminCampaignsFromDOM = exports.bootKindsFromDOM = exports.userIdFromDOM = exports.bootPreferencesFromDOM = exports.bootInboxFromDOM = void 0;
function readJsonScript(id, fallback) {
    var el = document.getElementById(id);
    if (!el || !el.textContent)
        return fallback;
    try {
        return JSON.parse(el.textContent);
    }
    catch (_a) {
        return fallback;
    }
}
function readJsonDataAttribute(id, attr, fallback) {
    var el = document.getElementById(id);
    var value = el === null || el === void 0 ? void 0 : el.getAttribute(attr);
    if (!value)
        return fallback;
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return fallback;
    }
}
var bootInboxFromDOM = function () {
    var payload = readJsonScript('msia-notifications-bootstrap', null);
    return payload;
};
exports.bootInboxFromDOM = bootInboxFromDOM;
var bootPreferencesFromDOM = function () {
    var payload = readJsonScript('msia-notifications-preferences-bootstrap', null);
    return payload;
};
exports.bootPreferencesFromDOM = bootPreferencesFromDOM;
var userIdFromDOM = function () { var _a, _b; var el = (_a = document.getElementById('notifications-preferences-container')) !== null && _a !== void 0 ? _a : document.getElementById('notifications-container'); if (!el) {
    return 0;
} var json = el.getAttribute('data-results'); var data = JSON.parse(json !== null && json !== void 0 ? json : '{}'); return (_b = data.userId) !== null && _b !== void 0 ? _b : 0; };
exports.userIdFromDOM = userIdFromDOM;
var bootKindsFromDOM = function () {
    return readJsonScript('msia-notification-kinds', null);
};
exports.bootKindsFromDOM = bootKindsFromDOM;
var bootAdminCampaignsFromDOM = function () {
    return readJsonScript('msia-admin-notifications-campaigns-bootstrap', null);
};
exports.bootAdminCampaignsFromDOM = bootAdminCampaignsFromDOM;
var bootAdminCampaignFromDOM = function () {
    return readJsonScript('msia-admin-notifications-campaign-bootstrap', null);
};
exports.bootAdminCampaignFromDOM = bootAdminCampaignFromDOM;
var bootAdminCampaignRoleOptionsFromDOM = function () {
    return readJsonDataAttribute('admin-notifications-campaign-container', 'data-role-options', []);
};
exports.bootAdminCampaignRoleOptionsFromDOM = bootAdminCampaignRoleOptionsFromDOM;
var bootAdminCampaignsRoleOptionsFromDOM = function () {
    return readJsonDataAttribute('admin-notifications-campaigns-container', 'data-role-options', []);
};
exports.bootAdminCampaignsRoleOptionsFromDOM = bootAdminCampaignsRoleOptionsFromDOM;
var bootAdminCampaignLanguageOptionsFromDOM = function () {
    return readJsonDataAttribute('admin-notifications-campaign-container', 'data-language-options', []);
};
exports.bootAdminCampaignLanguageOptionsFromDOM = bootAdminCampaignLanguageOptionsFromDOM;
var bootAdminCampaignsLanguageOptionsFromDOM = function () {
    return readJsonDataAttribute('admin-notifications-campaigns-container', 'data-language-options', []);
};
exports.bootAdminCampaignsLanguageOptionsFromDOM = bootAdminCampaignsLanguageOptionsFromDOM;
var bootAdminDeliveriesFromDOM = function () {
    return readJsonScript('msia-admin-notifications-deliveries-bootstrap', null);
};
exports.bootAdminDeliveriesFromDOM = bootAdminDeliveriesFromDOM;
var bootAdminEligibilityFromDOM = function () {
    return readJsonScript('msia-admin-notifications-eligibility-bootstrap', null);
};
exports.bootAdminEligibilityFromDOM = bootAdminEligibilityFromDOM;
var bootAdminDashboardFromDOM = function () {
    return readJsonScript('msia-admin-notifications-dashboard-bootstrap', null);
};
exports.bootAdminDashboardFromDOM = bootAdminDashboardFromDOM;
// TODO WHEN mobile push launches on production: strip out this mobile-feature guard
var mobilePrefEnabled = function () {
    var _a;
    return (_a = readJsonScript('msia-notification-features', { mobile_enabled: true })
        .mobile_enabled) !== null && _a !== void 0 ? _a : true;
};
exports.mobilePrefEnabled = mobilePrefEnabled;
var bootUnreadOnlyFromDOM = function () {
    // Prefer whichever bootstrap exists on the page
    var inbox = (0, exports.bootInboxFromDOM)();
    if (inbox)
        return { userId: inbox.userId, unreadCount: inbox.unreadCount };
    var prefs = (0, exports.bootPreferencesFromDOM)();
    if (prefs)
        return { userId: prefs.userId, unreadCount: prefs.unreadCount };
    return { userId: 0, unreadCount: 0 };
};
exports.bootUnreadOnlyFromDOM = bootUnreadOnlyFromDOM;
